import { Capacitor } from "@capacitor/core";
import toast from "react-hot-toast";
import { Printer } from "@bcyesil/capacitor-plugin-printer";



export const HtmlToPrintAllPlatforms = (content: string) => {
  return `
      <html>
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <style>
            /* Tailwind via CDN */
            @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');
    
            /* Custom Print Styles */
            .invoice-container {
            padding: 8px 2rem;
            margin: 0 auto;
            flex-direction: column;
            gap: 0.25rem;
          }

            /* Borders */
            .border-b-2 { border-bottom-width: 2px; }
            .border-b-black { border-bottom-color: black; }

            div[dir="ltr"].flex.font-semibold.ml-auto.items-center.justify-between {
              width :80%;
              margin-left : auto;
            }

            div[dir="ltr"].flex.font-semibold.ml-auto.items-center.justify-between .flex.flex-col.text-end {
              width :50%;
            }

            .text-end {
              text-align: end;
            }
            

          @media print {
            /* Hide everything by default */
            body * {
              visibility: hidden !important;
            }

            /* Show only the print container and its children */
            .print,
            .print * {
              visibility: visible !important;
            }

            /* Optional: make sure layout is correct */
            .print {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              display: flex !important;
              flex-direction: column;
            }

            @page {
              size: 148mm 210mm; /* A5 */
              margin: 10mm;
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 12pt;
              line-height: 1.5;
            }

            .print-item {
              page-break-after: always;
            }

            .print-item:last-child {
              page-break-after: auto;
            }
          }
    
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `;
};

const handleMobilePrint = async (
  contentRef: React.RefObject<HTMLDivElement>,
  afterPrintFn?: () => void,
): Promise<void> => {
  try {
    const content = contentRef.current?.outerHTML;
    if (!content) {
      toast.error("يرجى اختيار طلب واحد علي الاقل ");
      return;
    }

    const htmlToPrint = HtmlToPrintAllPlatforms(content);
    await Printer.print({ content: htmlToPrint });

    if (afterPrintFn) {
      afterPrintFn();
    }
  } catch (error) {
    console.error("Printing failed:", error);
    toast.error("فشل الطباعة");
  }
};

export const handlePrintForAllPlatforms = (
  reactToPrintFn: () => void,
  contentRef: React.RefObject<HTMLDivElement>,
  afterPrintFn?: () => void,
): void => {
  const platform = Capacitor.getPlatform();

  if (platform === "web") {
    reactToPrintFn();
  } else {
    handleMobilePrint(contentRef,afterPrintFn);
  }
};
